import { formatters } from "@garantidos/utils"

import { fields } from "../../../SimulationWithResults/components/Form/fields"

const infoOrder = ["creditValue", "financingTerm", "propertyValue"]

const alternativeLabel = {
  creditValue: "valor do crédito",
  financingTerm: "prazo de",
  propertyValue: "valor do seu imóvel"
}

export const getData = (proposalData) => {
  const data = []

  infoOrder.forEach((info) => {
    const field = fields[info]
    if (!field) return
    const rawValue = proposalData[field.name]
    if (rawValue === undefined) return
    const formatter =
      field.type === "ids-currency"
        ? formatters.fetchFormatters.displayableNumber
        : formatters.fetchFormatters[field.fetchFormat]

    const value = formatter ? formatter({ value: rawValue }) : rawValue
    const sufix = info === "financingTerm" ? "anos" : ""
    const prefix = field.type === "ids-currency" ? "R$" : ""
    const label = alternativeLabel[info] || field.label

    data.push({
      label,
      value: `${prefix} ${value} ${sufix}`,
      highlight: info === "creditValue" ? true : false,
      callerId: info === "financingTerm" ? "term" : null
    })
  })

  return data
}
